import {Table, TableContainer, Typography, Grid} from "@mui/material";
import {BetboardTableHeaders} from "../../organisms/BetboardTable/components/BetboardTableHeaders";
import {LoadingRow} from "./LoadingRow";
import React from "react";
import {LoadingSkeleton} from "./LoadingSkeleton";
import {QuerySummaryTableHeaders} from "../../pages/QueryPage/components/QuerySummaryTable/components/QuerySummaryTableHeaders";

export const LoadingSummaryTable = ({items}: {items?: number}) => {
    return (
        <Grid item container xs={12}>
            <TableContainer
                sx={{
                    maxWidth: '96%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '40px',
                    marginTop: '8px'
                }}
            >
                <Table
                    sx={{minWidth: 650}}
                    aria-label="simple table"
                >
                    <QuerySummaryTableHeaders />
                    <LoadingRow items={8}/>
                </Table>
            </TableContainer>
        </Grid>
    )
}